<template>
  <span id="chronometer">{{ chronometer }}</span>
</template>
<script>
export default {
  name: "chronometer",
  props: {
    isCall: {
      type: Boolean, 
      default: false
    },
  },
  data() {
    return {
      callSecondsCounter: { hours: 0, minutes: 0, seconds: "00" },
      startTime: new Date().getTime(),
      updateInterval: null,
    };
  },

  computed: {
    chronometer() {
      if (this.callSecondsCounter.hours) {
        return ` ${this.callSecondsCounter.hours}:${this.callSecondsCounter.minutes}:${this.callSecondsCounter.seconds}`;
      }
      return ` ${this.callSecondsCounter.minutes}:${this.callSecondsCounter.seconds}`;
    },
  },
  mounted() {
    const currentTime = new Date().getTime();
    let lastActiveTime = this.$store.getters.getLastActiveTime;
    if (lastActiveTime == null || lastActiveTime == undefined || (this.$props.isCall == true)) {
      this.$store.commit("changeLastActiveTime", currentTime);
      lastActiveTime = currentTime
    }
    const elapsedSeconds = (currentTime - lastActiveTime) / 1000;
    this.startTimer(elapsedSeconds);

  },

  methods: {
    startTimer(initialSeconds) {
      this.updateInterval = setInterval(() => {
        this.updateTimer(initialSeconds);
      }, 1000);
    },
    updateTimer(initialSeconds) {
      const currentTime = new Date().getTime();
      const elapsedSeconds = parseInt(initialSeconds) + ((currentTime - this.startTime) / 1000);

      const hours = Math.floor((elapsedSeconds) / 3600);
      const minutes = Math.floor((elapsedSeconds % 3600) / 60);
      const seconds = Math.floor(elapsedSeconds % 60);

      this.callSecondsCounter.seconds = seconds < 10 ? "0" + seconds : seconds;
      this.callSecondsCounter.hours = hours;
      this.callSecondsCounter.minutes = minutes;
    },
  },
};
</script>

<style scoped>
#chronometer {
  margin-left: 5px;
}
</style>
